module.exports = __webpack_public_path__ + "img/compliance.c7522c13.png";